module.exports = __webpack_public_path__ + "static/img/logo.4ccbe05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/globalheader/logo.jpg
// module id = BpKg
// module chunks = 1